import React, { useEffect, useState } from 'react';
import { Box, Grid, InputAdornment, Typography } from '@mui/material';

import { ButtonUI, DialogUI, FormLabelUI, InputUI } from '../Interface';
import itemService from '../../service/item.service';
import { downloadFile, printFromResponse } from '../../utils/download';
import { add } from 'lodash';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';

const ItemLabelDialog = (props) => {
  const { open, onClose, selectedValuesState } = props;

  const { selectedValues } = selectedValuesState;

  const label = 'Cikk címke';

  const labelData = {
    itemCode: selectedValues?.itemCode ?? '',
    itemName: selectedValues?.itemName ?? '',
    quantity: 1,
    unitPrice: 0,
    qtyUnit: selectedValues?.quantityUnit?.code ?? '',
    barCode: selectedValues?.barCode ?? '',
    labelQuantity: 1,
  };

  const [labelDataState, setLabelDataState] = useState({});

  useEffect(() => {
    if (!selectedValues) setLabelDataState({});
    else setLabelDataState(labelData);
  }, [selectedValues]);

  const handlePrintClick = async () => {
    const response = await itemService.createLabel(labelDataState);

    if (window.nativePrint) {
      printFromResponse(response, response.filename, labelDataState.labelQuantity);

      return;
    }

    downloadFile(response, response.filename);

    addNotification({
      content: 'Címke nyomtatás elindítva',
      type: NotificationType.SUCCESS,
    });
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent={label} maxWidth="md" fullWidth>
      <Grid container spacing={1} mt={1} sx={{ background: '#E9F5FE', borderRadius: '4px', p: '0.5rem' }}>
        {/* Left column */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={0.5} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Cikkszám
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{selectedValues?.itemCode}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container spacing={0.5} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">
                Cikknév
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{selectedValues?.itemName}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* ide kellenek az inputok */}

      <Grid container spacing={2} mt={1} p={1}>
        <Grid item xs={12} md={4}>
          <InputUI
            name="quantity"
            label={<FormLabelUI text="Címkén szereplő mennyiség" />}
            type="number"
            value={labelDataState.quantity}
            variant="standard"
            onChange={(e) => setLabelDataState({ ...labelDataState, quantity: e.target.value })}
            InputProps={{
              endAdornment: <InputAdornment position="end">{selectedValues?.quantityUnit?.code}</InputAdornment>,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputUI
            name="unitPrice"
            label={<FormLabelUI text="Egységár" />}
            type="number"
            value={labelDataState.unitPrice}
            variant="standard"
            onChange={(e) => setLabelDataState({ ...labelDataState, unitPrice: e.target.value })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputUI
            name="labelQuantity"
            label={<FormLabelUI text="Címke mennyiség" />}
            type="number"
            value={labelDataState.labelQuantity}
            variant="standard"
            onChange={(e) => setLabelDataState({ ...labelDataState, labelQuantity: e.target.value })}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">db</InputAdornment>,
            }}
          />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI text="Nyomtatás" className="bg-success" onClick={handlePrintClick} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default ItemLabelDialog;
